module.exports = __webpack_public_path__ + "static/media/humans.1eb325e1.svg";